import axios from "axios";
import {GlobalService} from "@/services/GlobalService";
import {
  AIR_CHARTS,
  AIR_REPORT_STATUS_COUNTS,
  AIR_SAFETY_AND_HEALTH_CHARTS_DATA,
  RS_REPORT_STATUS_COUNTS,
  RS_CHARTS,
  VESSEL_ACCIDENT_INCIDENT_LOSS_REPORT, AIR_YEARLY_SUMMARY, TOKEN_NAME
} from "@/services/ConstantService";
import {UrlService} from "./UrlService";

export const DashboardService= {
  async getAirReportStatusCounts(params) {
    let queryString=UrlService.setQueryString(params)
    return await axios.get(AIR_REPORT_STATUS_COUNTS + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      if (localStorage.getItem(TOKEN_NAME)) {
        GlobalService.handleError(error, 'GET AIR REPORT STATUS COUNT SERVICE')
      }
      return false
    })
  },
  async getRsReportStatusCounts(params) {
    let queryString=UrlService.setQueryString(params)
    return await axios.get(RS_REPORT_STATUS_COUNTS + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      if (localStorage.getItem(TOKEN_NAME)) {
        GlobalService.handleError(error, 'GET RS REPORT STATUS COUNT SERVICE')
      }
      return false
    })
  },
  async getAccidentCharts(params){
    let queryString=UrlService.setQueryString(params);
    return await axios.get(AIR_CHARTS + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET AIR CHART SERVICE')
      return false
    })
  },
  async getRsCharts(params){
    let queryString=UrlService.setQueryString(params);
    return await axios.get(RS_CHARTS + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      if (localStorage.getItem(TOKEN_NAME)) {
        GlobalService.handleError(error, 'GET RS CHART SERVICE')
      }
      return false
    })
  },
  async getAccidentSafetyAndHealthChartsData(params){
    let queryString=UrlService.setQueryString(params);
    return await axios.get(AIR_SAFETY_AND_HEALTH_CHARTS_DATA + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET AIR CHART FOR SAFETY AND HEALTH SERVICE')
      return false
    })
  },
  async getDashboardAccidentIncidentLossReport(params) {
    return await axios.post(VESSEL_ACCIDENT_INCIDENT_LOSS_REPORT, params).then(res => {
      return res.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET VESSEL ACCIDENT INCIDENT LOSS REPORT SERVICE')
      return false
    })
  },
  async getDashboardAIYearlySummary(params) {
    let newParams = {
      year : params.year
    };

    if (params.module === 'safety_and_health') {
      newParams.feature = params.feature;
    }
    let queryString= UrlService.setQueryString(newParams);
    return await axios.get(AIR_YEARLY_SUMMARY.replace('{module}', params.module) + queryString).then(res => {
      return res.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET AIR YEARLY SUMMARY SERVICE')
      return false
    })

  }
}
